// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--2lAVP";
export var noHoverStyle = "styles-module--noHoverStyle--35sXC";
export var smartLink = "styles-module--smartLink--1ztdM";